import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress noisy Chromium "ResizeObserver loop" errors that don't affect functionality
const isResizeObserverLoopError = (value) => {
  const message =
    value instanceof Error ? value.message : typeof value === 'string' ? value : '';
  return typeof message === 'string' && message.includes('ResizeObserver loop completed');
};

// 1) Filter it out from the console so it doesn't spam dev tools
const originalConsoleError = window.console.error.bind(window.console);
window.console.error = (...args) => {
  if (args.length > 0 && isResizeObserverLoopError(args[0])) {
    return;
  }
  originalConsoleError(...args);
};

// 2) Filter it out from the window error handler so React's overlay doesn't show it
window.addEventListener(
  'error',
  (event) => {
    if (isResizeObserverLoopError(event?.error || event?.message)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
